"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubTypesByType = exports.AllSubTypes = exports.EarningSubType = exports.ReligiousNPOTypes = exports.NPOTypes = exports.ContractorTypes = exports.ContractContractorTypes = exports.NonHourlyTypes = exports.HourlyTypes = exports.AllOptions = exports.EarningType = void 0;
exports.EarningType = Object.freeze({
    AMOUNT_TIME: {
        label: 'Payment (hours)',
        value: 'AMOUNT_TIME',
    },
    AMOUNT_VALUE: {
        label: 'Payment (dollars)',
        value: 'AMOUNT_VALUE',
    },
    BONUS: {
        label: 'Bonus',
        value: 'BONUS',
    },
    CASH_TIPS: {
        label: 'Cash Tips',
        value: 'CASH_TIPS',
    },
    COMMISSION: {
        label: 'Commission',
        value: 'COMMISSION',
    },
    DOUBLE_OVERTIME: {
        label: 'Double Overtime',
        value: 'DOUBLE_OVERTIME',
    },
    GROUP_TERM_LIFE: {
        label: 'Group Term Life',
        value: 'GROUP_TERM_LIFE',
    },
    HOURLY: {
        label: 'Regular Hours',
        value: 'HOURLY',
    },
    OTHER_IMPUTED: {
        label: 'Other Imputed',
        value: 'OTHER_IMPUTED',
    },
    OVERTIME: {
        label: 'Overtime',
        value: 'OVERTIME',
    },
    PAID_HOLIDAY: {
        label: 'Paid Holiday (1x)',
        value: 'PAID_HOLIDAY',
    },
    PAID_HOLIDAY_1_5X: {
        label: 'Paid Holiday (1.5x)',
        value: 'PAID_HOLIDAY_1_5X',
    },
    PAYCHECK_TIPS: {
        label: 'Paycheck Tips',
        value: 'PAYCHECK_TIPS',
    },
    PTO: {
        label: 'PTO',
        value: 'PTO',
    },
    REIMBURSEMENT: {
        label: 'Reimbursement',
        value: 'REIMBURSEMENT',
    },
    SALARIED: {
        label: 'Salary  ',
        value: 'SALARIED',
    },
    SEVERANCE: {
        label: 'Severance',
        value: 'SEVERANCE',
    },
    SICK: {
        label: 'Sick',
        value: 'SICK',
    },
    NON_HOURLY_REGULAR: {
        label: 'Non-hourly Regular',
        value: 'NON_HOURLY_REGULAR',
    },
    ALLOWANCE: {
        label: 'Allowance',
        value: 'ALLOWANCE',
    },
    REPORTED_ALLOWANCE: {
        label: 'Reported Allowance',
        value: 'REPORTED_ALLOWANCE',
    },
    CLERGY_HOUSING: {
        label: 'Clergy Housing',
        value: 'CLERGY_HOUSING',
    },
    REPORTED_CLERGY_HOUSING: {
        label: 'Reported Clergy Housing',
        value: 'REPORTED_CLERGY_HOUSING',
    },
});
exports.AllOptions = [
    exports.EarningType.SALARIED,
    exports.EarningType.HOURLY,
    exports.EarningType.OVERTIME,
    exports.EarningType.DOUBLE_OVERTIME,
    exports.EarningType.PTO,
    exports.EarningType.SICK,
    exports.EarningType.CASH_TIPS,
    exports.EarningType.PAID_HOLIDAY,
    exports.EarningType.PAID_HOLIDAY_1_5X,
    exports.EarningType.PAYCHECK_TIPS,
    exports.EarningType.BONUS,
    exports.EarningType.COMMISSION,
    exports.EarningType.REIMBURSEMENT,
    exports.EarningType.SEVERANCE,
    exports.EarningType.NON_HOURLY_REGULAR,
    exports.EarningType.ALLOWANCE,
    exports.EarningType.REPORTED_ALLOWANCE,
    exports.EarningType.CLERGY_HOUSING,
    exports.EarningType.REPORTED_CLERGY_HOUSING,
];
exports.HourlyTypes = [
    exports.EarningType.AMOUNT_TIME,
    exports.EarningType.DOUBLE_OVERTIME,
    exports.EarningType.HOURLY,
    exports.EarningType.OVERTIME,
    exports.EarningType.PAID_HOLIDAY,
    exports.EarningType.PAID_HOLIDAY_1_5X,
    exports.EarningType.PTO,
    exports.EarningType.SALARIED,
    exports.EarningType.SICK,
];
exports.NonHourlyTypes = [
    exports.EarningType.AMOUNT_VALUE,
    exports.EarningType.BONUS,
    exports.EarningType.CASH_TIPS,
    exports.EarningType.COMMISSION,
    exports.EarningType.GROUP_TERM_LIFE,
    exports.EarningType.OTHER_IMPUTED,
    exports.EarningType.PAYCHECK_TIPS,
    exports.EarningType.REIMBURSEMENT,
    exports.EarningType.SEVERANCE,
    exports.EarningType.NON_HOURLY_REGULAR,
    exports.EarningType.ALLOWANCE,
    exports.EarningType.REPORTED_ALLOWANCE,
    exports.EarningType.CLERGY_HOUSING,
    exports.EarningType.REPORTED_CLERGY_HOUSING,
];
exports.ContractContractorTypes = [exports.EarningType.AMOUNT_VALUE, exports.EarningType.REIMBURSEMENT];
exports.ContractorTypes = [exports.EarningType.AMOUNT_TIME, exports.EarningType.AMOUNT_VALUE, exports.EarningType.REIMBURSEMENT];
exports.NPOTypes = [exports.EarningType.ALLOWANCE, exports.EarningType.REPORTED_ALLOWANCE];
exports.ReligiousNPOTypes = [
    exports.EarningType.ALLOWANCE,
    exports.EarningType.REPORTED_ALLOWANCE,
    exports.EarningType.CLERGY_HOUSING,
    exports.EarningType.REPORTED_CLERGY_HOUSING,
];
exports.EarningSubType = Object.freeze({
    GIFT: {
        label: 'Gift',
        value: 'GIFT',
    },
    DISCRETIONARY: {
        label: 'Discretionary',
        value: 'DISCRETIONARY',
    },
    NON_DISCRETIONARY: {
        label: 'Non-Discretionary',
        value: 'NON_DISCRETIONARY',
    },
});
exports.AllSubTypes = [exports.EarningSubType.GIFT, exports.EarningSubType.DISCRETIONARY, exports.EarningSubType.NON_DISCRETIONARY];
exports.SubTypesByType = {
    [exports.EarningType.BONUS.value]: [exports.EarningSubType.GIFT, exports.EarningSubType.DISCRETIONARY, exports.EarningSubType.NON_DISCRETIONARY],
};
//# sourceMappingURL=earning-types.js.map